import { ChevronDown, Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import "./Header.css"; 
import logo from "../assets/textlogo.png"

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const toggleSubmenu = (name) => {
    setOpenSubmenu(openSubmenu === name ? null : name);
  };

  return (
    <header className="header">
      <div className="header-container">

        <div className="logo">
          {/* <span className="logo-text">TREDIXO</span> */}
              <img src={logo}  alt="" style={{height:50,width:80}}  />
        </div>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>

          <NavLink to="/" end className="nav-link">
            Home
          </NavLink>

          {/* ABOUT */}
          <div className="nav-item">
            <button
              className={`nav-link nav-link-btn ${openSubmenu === "about" ? "active" : ""}`}
              onClick={() => toggleSubmenu("about")}
            >
              About Us <ChevronDown size={16} />
            </button>

            {openSubmenu === "about" && (
              <div className="dropdown">
                <NavLink to="/why-tredixo" className="dropdown-link">Why Tredixo</NavLink>
                <NavLink to="/affiliate" className="dropdown-link">Become An Affiliate</NavLink>
                <NavLink to="/privacy-policy" className="dropdown-link">Privacy Policy</NavLink>
                <NavLink to="/terms-conditions" className="dropdown-link">Terms & Conditions</NavLink>
              </div>
            )}
          </div>

          {/* KNOWLEDGE */}
          <div className="nav-item">
            <button
              className={`nav-link nav-link-btn ${openSubmenu === "knowledge" ? "active" : ""}`}
              onClick={() => toggleSubmenu("knowledge")}
            >
              Knowledge Center <ChevronDown size={16} />
            </button>

            {openSubmenu === "knowledge" && (
              <div className="dropdown">
                <NavLink to="/trading" className="dropdown-link">Trading</NavLink>
                <NavLink to="/equity-trading" className="dropdown-link">Equity Trading</NavLink>
                <NavLink to="/futures-options" className="dropdown-link">Futures & Options</NavLink>
                <NavLink to="/commodity-trading" className="dropdown-link">Commodity Trading</NavLink>
                <NavLink to="/margin-trading" className="dropdown-link">Margin Trading</NavLink>
                <NavLink to="/intraday-trading" className="dropdown-link">Intraday Trading</NavLink>
              </div>
            )}
          </div>

          <NavLink to="/news-blogs" className="nav-link">
            News & Blogs
          </NavLink>

          <NavLink to="/contact" className="nav-link">
            Contact Us
          </NavLink>

         <div className="auth-segment">
  <button
    className="segment-btn signup"
    onClick={() =>
      window.open(
        "https://web.theplatformapi.com/create-company-user?companyName=TREDIXO&isDemo=false&parentId=6",
        "_blank"
      )
    }
  >
    Sign Up
  </button>

  <button
    className="segment-btn login"
    onClick={() =>
      window.open(
        "https://web.theplatformapi.com/login",
        "_blank"
      )
    }
  >
    Login
  </button>
</div>


        </nav>
      </div>
    </header>
  );
};

export default Header;
